import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=53242ca6&scoped=true&"
import script from "./sms.vue?vue&type=script&lang=js&"
export * from "./sms.vue?vue&type=script&lang=js&"
import style0 from "./sms.vue?vue&type=style&index=0&id=53242ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53242ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53242ca6')) {
      api.createRecord('53242ca6', component.options)
    } else {
      api.reload('53242ca6', component.options)
    }
    module.hot.accept("./sms.vue?vue&type=template&id=53242ca6&scoped=true&", function () {
      api.rerender('53242ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/sms.vue"
export default component.exports